
import { Avatar, Box } from "@mui/material";
import DataTable from "app/components/DataTable";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { adminManagementTableRow } from "../../types";
import { useStyles } from "./styles";

type Props = {
  rows: adminManagementTableRow[] | undefined;
  loading?: boolean;
};

 const AdminManagementTable = ({ rows, loading = false }: Props) => {
  const { t } = useTranslation();
  const styles = useStyles();



  const columns = useMemo(
    () => [
      {
        id: "departureDate",
        label: t("ADMIN_MANAGEMENT.TABLE.DEPARTURE_DATE"),
        minWidth: 140,
        align: "right",
      },
        {
        id: "status",
        label: t("ADMIN_MANAGEMENT.TABLE.STATUS"),
        minWidth: 100,
        align: "right",
        format: (row: adminManagementTableRow) => (
                  <span className={styles.statusBadge}>
                    {t(`ADMIN_MANAGEMENT.STATUS_VALUES.${row.status}`)}
                  </span>
                ),
      },
      {
        id: "department",
        label: t("ADMIN_MANAGEMENT.TABLE.DEPARTMENT"),
        minWidth: 140,
        align: "right",
        format: (row: adminManagementTableRow) => t(row.department),
      },
       {
        id: "mail",
        label: t("ADMIN_MANAGEMENT.TABLE.EMAIL"),
        minWidth: 160,
        align: "right",
      },
      {
        id: "phone",
        label: t("ADMIN_MANAGEMENT.TABLE.PHONE"),
        minWidth: 120,
        align: "right",
      },
       {
        id: "role",
        label: t("ADMIN_MANAGEMENT.TABLE.ROLE"),
        minWidth: 120,
        align: "right",
        format: (row: adminManagementTableRow) => t(row.role),
      },
      {
        id: "fullName",
        label: t("ADMIN_MANAGEMENT.TABLE.FULL_NAME"),
        minWidth: 140,
        align: "right",
         format: (row:adminManagementTableRow) => (
          <Box className={styles.contactCell}>
            <span>{t(row.fullName)}</span>
            <Avatar className={styles.avatar}>{row.initials}</Avatar>
          </Box>
        ),
      },
    ],
    [styles, t]
  );

  return (
    <div className={styles.root}>
      <DataTable
        rows={rows || []}
        columns={columns}
        loading={loading}
        serialEnabled={false}
        isPointerCursor
      />
    </div>
  );
};

export default AdminManagementTable;
